import { createContext } from "react";

export const VisitasContext = createContext()
export const VisitasFormContext = createContext()
export const VisitasReportContext = createContext()